import { Injectable } from '@angular/core';

import { ListaCompartilhadaService } from '../../../shared/lista-compartilhada.service';
import { OperacaoGarantida } from 'src/app/model/operacao-garantida.model';

@Injectable({
    providedIn: 'root'
  })
export class ListaOperacoesService extends ListaCompartilhadaService<OperacaoGarantida> {

}
